import React, { useState } from 'react';
import { ASSETS } from '../assetManifest';

function StoryOverlay({ beat, onDismiss }) {
  const [currentLine, setCurrentLine] = useState(0);

  const handleNext = () => {
    if (currentLine < beat.lines.length - 1) {
      setCurrentLine(currentLine + 1);
    } else {
      onDismiss();
    }
  };

  const line = beat.lines[currentLine];
  const speakerImage = ASSETS.speakers[line.speaker.id];

  return (
    <div className="Storyoverlay w-[390px] h-[690px] relative overflow-hidden absolute inset-0 z-50">
      <img 
        className="StoryOverlay1 w-[390px] h-[844px] left-0 top-[-100px] absolute" 
        src={ASSETS.backgrounds.storyOverlayBackground.path} 
        alt="Story Background"
      />
      
      <div className="DialogueDetails w-[390px] h-[417px] left-0 top-[273px] absolute">
        {speakerImage && (
          <img 
            className="CharacterImage w-40 h-60 left-0 top-0 absolute" 
            src={speakerImage.path}
            alt={line.speaker.name}
          />
        )}
        
        <img 
          className="DialogueBg w-[390px] h-[220px] left-0 top-[197px] absolute" 
          src={ASSETS.ui.dialogueBackground.path} 
          alt="Dialogue Background"
        />
        
        <img 
          className="NextBtn w-[27px] h-[31px] left-[329px] top-[357px] absolute cursor-pointer" 
          src={ASSETS.ui.nextButton.path} 
          alt="Next"
          onClick={handleNext}
        />
        
        <div className="Dialogue w-[282px] h-[124px] left-[27px] top-[258px] absolute text-[#fff9ed] text-base font-extrabold font-Asap uppercase [text-shadow:_0px_4px_4px_rgb(0_0_0_/_0.25)]">
          {line.text}
        </div>
        
        <div className="CharacterName w-[336px] h-[37px] left-[27px] top-[214px] absolute text-[#efbb57] text-xl font-extrabold font-Asap uppercase [text-shadow:_0px_4px_4px_rgb(0_0_0_/_0.25)]">
          {line.speaker.name}
        </div>
      </div>
    </div>
  );
}

export default StoryOverlay;
